<!-- NOT IN USE -->
<template>
<v-container fluid>
    <div style="text-align:right">
        <a target="_blank" :href="manualLink" text-right>คู่มือการใช้งาน</a>
    </div>
    <v-card class="ma-2" flat>
        <member-list-component :userList="userList" :startDate="startDate" :endDate="endDate" :title="title" :loading="loading" :headers="headers" :owner="loggedInUserId" @toCreateGroupOverview="toCreateGroupOverview($event)" />
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import MemberListComponent from "../components/ProgramMemberListComponent.vue";
import moment from "moment";
import bqGetProgramMemberListById from "../data/bqGetProgramMemberListById";
export default {
    name: 'ProgramView',
    metaInfo: {
        title: 'Program View'
    },
    components: {
        MemberListComponent
    },
    data() {
        return {
            title: 'รายคน - แสดงเฉพาะข้อมูลลูกทีมที่รับผิดชอบในโปรแกรมเท่านั้น',
            manualLink: "https://www.thaisook.org/wp-content/uploads/2023/03/คู่มือการใช้งานระบบไทยสุข-PILM-สำหรับโค้ช.pdf",
            groupInfo: {
                // startDate: moment().subtract(10, 'd').format('YYYY-MM-DD'),
                // endDate: moment().format('YYYY-MM-DD')
            },
            //set default date from last 3 month
            isShowGroupFilter: false,
            startDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            loading: false,
            owner: false,
            userList: [],
            headers: [{
                    text: "",
                    value: "avatar",
                    sortable: false,
                },
                {
                    text: "สมาชิก",
                    value: "name",
                    cellClass: "pr-0",
                },
                {
                    text: "กลุ่ม",
                    value: "groupName",
                },
                {
                    text: "โปรแกรม",
                    value: "programName"
                },
                {
                    text: "วันที่เริ่ม",
                    value: "startDateFormated",
                    align: "center"
                },
                {
                    text: "วันที่จบโปรแกรม",
                    value: "endDateFormated",
                    align: "center"
                },
                {
                    text: "Action",
                    value: "actions",
                    sortable: false,
                }
            ],
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ])
    },
    methods: {
        initialize() {
            (async () => {
                if (this.loggedInUserId) {
                    this.toCreateGroupOverview({
                        startDate: this.startDate,
                        endDate: this.endDate,
                        isSubmit: true
                    });
                    this.loading = false;
                } else {
                    this.$router.push(`/dashboard`);
                }
            })();
        },

        //router
        goToProgrammList() {
            this.$router.push(`/program`);
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        calculatePercentChanges(a, b) {
            //get max value
            // return (b-a)/a*100;
            let pc = formatData('number', (b - a) / a * 100);
            if (pc > 0) {
                pc = `+${pc}`;
            }
            return pc;
        },
        calculateMaxY(a, b, maxY, point) {
            //get max value
            let maxValue = b;
            if (a > b) {
                maxValue = a;
            }

            //compare with maxY
            if (maxValue > maxY) {
                maxY = (maxValue * 1) + point;
            }
            return maxY;
        },
        toCreateGroupOverview(obj) {
            this.loading = true;
            this.startDate = obj.startDate;
            this.endDate = obj.endDate;
            this.groupInfo.isSubmit = obj.isSubmit;
            if (obj.isSubmit) {
                (async () => {
                    this.userList = await bqGetProgramMemberListById( 'owner', this.loggedInUserId );
                    this.loading = false;
                })();
            }
        },
        merge(a, b, prop) {
            var reduced = [];
            for (var i = 0; i < a.length; i++) {
                var aitem = a[i];
                var found = false;
                for (var ii = 0; ii < b.length; ii++) {
                    if (aitem[prop] === b[ii][prop]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    reduced.push(aitem);
                }
            }
            return reduced.concat(b);

        }
    }
};
</script>
